import { queryOptions } from "@tanstack/react-query";

import * as workspaceBillingApi from "./workspace-billing-api";

export const workspaceBillingQueries = {
  root: () => ["workspace-billing"] as const,
  summary: (workspaceId: string) =>
    queryOptions({
      queryKey: [...workspaceBillingQueries.root(), workspaceId, "summary"] as const,
      queryFn: () => workspaceBillingApi.getWorkspaceBillingSummary(workspaceId),
      staleTime: 30 * 1000,
    }),
  phase: (workspaceId: string) =>
    queryOptions({
      queryKey: [...workspaceBillingQueries.root(), workspaceId, "phase"] as const,
      queryFn: () => workspaceBillingApi.getWorkspaceSubscriptionPhase(workspaceId),
      staleTime: 15 * 1000,
    }),
  latestJob: (workspaceId: string) =>
    queryOptions({
      queryKey: [...workspaceBillingQueries.root(), workspaceId, "latest-job"] as const,
      queryFn: () => workspaceBillingApi.getLatestHyperlineJob(workspaceId),
      staleTime: 15 * 1000,
    }),
  creditState: (workspaceId: string) =>
    queryOptions({
      queryKey: [...workspaceBillingQueries.root(), workspaceId, "credit-state"] as const,
      queryFn: () => workspaceBillingApi.getWorkspaceCreditState(workspaceId),
      staleTime: 15 * 1000,
    }),
};
